import React from 'react';
import { useCustomComponent } from '@/hooks';
import clsx from 'clsx';

export interface QuestionnaireContainerProps {
  children: React.ReactNode;
  isFormSubmitting: boolean;
}

const ContainerComponent: React.FC<QuestionnaireContainerProps> = ({
  children,
  isFormSubmitting,
}) => {
  return (
    <div className="fade-in-up" style={{ animationDelay: '0.1s' }}>
      <div
        className={clsx(
          'peptalk-questionnaire',
          isFormSubmitting && 'submitting'
        )}
      >
        {children}
      </div>
    </div>
  );
};

export const Container: React.FC<QuestionnaireContainerProps> = (
  props: QuestionnaireContainerProps
) => {
  const Component = useCustomComponent({
    componentName: 'QuestionnaireContainer',
    Component: ContainerComponent,
  });

  return <Component {...props} />;
};
